import axios from '@/axios'
const state = {
    personType: [],
    documentType: [],
    sexualOrientation: [],
    unity: [],
    kinship: [],
    loaded: false,
}

const getters = {
    getPersonType: state => state.personType,
    getDocumentType: state => state.documentType,
    getSexualOrientation: state => state.sexualOrientation,
    getUnity: state => state.unity,
    getKinship: state => state.kinship,
}

const mutations = {
    setLookups(state, lookups) {
        Object.assign(state, lookups)
    },
    setResetLoaded(state) {
        state.loaded = false
    }
}

const actions = {
    async fetchLookupsDefault({ state, commit }) {
        if (state.loaded) return
        const { data: lookups } = await axios.get('/lookups')
        commit('setLookups', lookups)
    },
    resetLoaded({ commit }) {
        commit('setResetLoaded')
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}
